import { Button, CustomButtonVariant } from "@shared/components/md-design-system/Button/Button";
import { IconNames } from "@ant-design/react-native/lib/icon";

interface IActivityCtaButtonProps {
    variant?: CustomButtonVariant;
    icon?: IconNames;
    onPress?: () => void;
    disabled?: boolean;
    children: React.ReactNode;
    block?: boolean;
    compact?: boolean;
}

export const ActivityCtaButton = ({ variant = 'primary', icon, onPress, disabled, children, block = false, compact = false }: IActivityCtaButtonProps) => (
    <Button
        variant={variant}
        icon={icon}
        onPress={onPress}
        disabled={disabled}
        style={
            block
                ? { borderRadius: 12, minHeight: 56, marginVertical: 0, marginTop: 16, alignSelf: 'stretch' }
                : { borderRadius: 12, minHeight: compact ? 42 : 50, width: 140, marginVertical: 0 }
        }
    >
        {children}
    </Button>
);

export default ActivityCtaButton;
